/* custom js scripts */


// Used this way doc ready event. Standard way of jquery doc ready does not work.
window.onload = function() {
    
    // move second link in header inline menu (collections) after logo
    $('.header__inline-menu').before($('.header__inline-menu ul li:nth-of-type(2) a').removeClass().addClass('button button--primary'));
    
    // tooggle custom langs / domain selector
    $('.header__localization--language-custom .localization-selector').on('click', function(event){ 
        event.preventDefault()
        $('.header__localization--language-custom .disclosure__list ').toggle(); 
        
    });
}



